import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BonnetClosedIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4.04004 15.2609H4.04139H11.6497H12.8288L13.2999 16.3418C13.4755 16.7449 13.6972 16.9497 13.888 17.0601C14.09 17.177 14.3357 17.2324 14.603 17.2131C15.2041 17.1697 15.5917 16.8072 15.6887 16.5072L16.0916 15.2609H17.4014H18.1734C18.177 15.2513 18.1778 15.2448 18.1778 15.2448V14.012C18.106 13.4831 17.9845 13.1935 17.8788 13.0251C17.7783 12.8653 17.6333 12.7195 17.3479 12.5676C16.6281 12.1846 15.4989 11.9715 13.3646 11.5754L13.071 11.5209L12.8107 11.3745L9.86148 9.71562L9.82994 9.69788L9.79913 9.67888C9.13832 9.27139 8.38593 9.05789 7.62148 9.05781L4.04004 9.0586V7.2586L7.62109 7.25781C8.72224 7.25781 9.80146 7.5656 10.7439 8.14676L13.6932 9.80561L13.9741 9.85768C17.769 10.5604 19.6235 10.9038 19.9774 13.8954L19.9778 13.9076V15.2463C19.9778 16.1726 19.2436 17.0867 18.1974 17.0609H17.4014C16.6727 19.3148 12.9307 20.0004 11.6497 17.0609H4.04139L4.04004 17.0644V15.2609Z"
      />
    </SvgIcon>
  );
});
